﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../../utilities/crud-functions';
import SearchMethodsComponent from '../Methods/SearchMethodsComponent';
import { ModalMessageType, AnalyticalPlanMethodLocationTypes } from '../../models/enums';
import { MethodSearch } from '../../models/Methods/method-search';
import { AnalyticalPlan } from '../../models/analytical-plan';
import { LookupData } from '../../models/lookup-data';
import { LookupItem } from '../../models/lookup-item';
import DataTemplates from '../../templates/data-templates';
import { ModalMetadata } from '../../models/modal-metadata';
import GlobalDialog from '../Modal/GlobalDialog';
import { ToastProps } from '../../models/toast-props';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import RadioGroup from 'devextreme-react/radio-group';
import List from 'devextreme-react/list';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

import {
    Validator,
    StringLengthRule
} from 'devextreme-react/validator';
import { Method } from '../../models/Methods/method';

let key = 0;

export interface Props {
    analyticalPlanId: string;
    isReadOnly: boolean;
    lookupData: LookupData;
    onClose?: () => void;
}

export default function AnalyticalPlanEditComponent(props: Props) {
    const [testingLocationTypes, setTestingLocationTypes] =
        useState<LookupItem[]>();

    const [methodSourceTypes, setMethodSourceTypes] =
        useState<LookupItem[]>();

    const [analyticalPlan, setAnalyticalPlan] =
        useState<AnalyticalPlan>();

    const [analysisScopesSelectedItemKeys, setAnalysisScopesSelectedItemKeys] =
        useState<number[]>();

    const [analyticalPlanBasisTypesSelectedItemKeys, setAnalyticalPlanBasisTypesSelectedItemKeys] =
        useState<number[]>();

    const [methodSearchByPartNumberDialogVisible, setMethodSearchByPartNumberDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.analyticalPlanId]);

    ++key;

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="save-toolbar pw-margin-right-05">
                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height={'1.8rem'}
                        onClick={onSaveClick} />

                    <Button id="cancelButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height={'1.8rem'}
                        onClick={onCloseClick} />
                </div>
            </div>

            {analyticalPlan &&
                <div>
                    <div className="pw-comp-row pw-margin-top-1">
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Technology</div>
                            <SelectBox id="analyticalTechnologyId" className="selectbox"
                                placeholder='NA'
                                displayExpr='name' valueExpr='id'
                                dataSource={props.lookupData && props.lookupData.technologyTypes ?
                                    props.lookupData.technologyTypes : []}
                                onValueChanged={onAnalyticalPlanValueChanged}
                                value={analyticalPlan.analyticalTechnologyId ? analyticalPlan.analyticalTechnologyId : undefined} />
                        </div>

                        {/* KEEP FOR NOW
                        <div className="pw-form-unit pw-comp-10">
                            <div className="pw-form-unit-label">Version #</div>
                            <NumberBox id="methodVersionNumber" className="textbox"
                                disabled={true}
                                value={analyticalPlan ? analyticalPlan.methodVersionNumber : undefined} />
                        </div>
                        */}

                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Testing Method</div>
                            <RadioGroup id="testingLocation" items={testingLocationTypes ? testingLocationTypes : []}
                                displayExpr='name' valueExpr='id' layout="horizontal"
                                value={analyticalPlan && analyticalPlan.testingLocation ? analyticalPlan.testingLocation : undefined}
                                onValueChanged={onAnalyticalPlanValueChanged} />
                        </div>

                    </div>

                    {(analyticalPlan && analyticalPlan.testingLocation && analyticalPlan.testingLocation === AnalyticalPlanMethodLocationTypes.InHouse) &&
                        <div>

                            <div className="pw-comp-row pw-margin-top-05">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Method Number</div>
                                    <div className="pw-readonly-label">{analyticalPlan && analyticalPlan.methodName ?
                                        analyticalPlan.methodName : 'NA'}</div>
                                </div>

                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Method State</div>
                                    <div className="pw-readonly-label">{analyticalPlan && analyticalPlan.methodStateName ?
                                        analyticalPlan.methodStateName : 'NA'}</div>
                                </div>

                                <Button id="searchMethodButton" text="" icon="search" type="success"
                                    className="pw-row-button-09"
                                    hint="search methods"
                                    height='1.6rem'
                                    onClick={onSearchMethodsClick} />

                                <Button id="createMethodButton" text="Create Method"
                                    icon="plus" type="success"
                                    className="pw-margin-left-05 pw-row-button-09"
                                    hint="create new method"
                                    height='1.6rem'
                                    onClick={onCreateMethodClick} />
                            </div>

                        </div>
                    }

                    {(analyticalPlan && analyticalPlan.testingLocation && analyticalPlan.testingLocation === AnalyticalPlanMethodLocationTypes.OutOfHouse) &&
                        <div>
                            <div className="pw-comp-row pw-margin-top-1">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Method Source</div>
                                    <RadioGroup id="methodSource" items={methodSourceTypes ? methodSourceTypes : []}
                                        displayExpr='name' valueExpr='id' layout="horizontal"
                                        value={analyticalPlan && analyticalPlan.methodSource ? analyticalPlan.methodSource : undefined}
                                        onValueChanged={onAnalyticalPlanValueChanged} />
                                </div>

                                <div className="pw-form-unit pw-comp-40">
                                    <div className="pw-form-unit-label">Method Document and Section</div>
                                    <TextBox id="methodDocumentSection" className="textbox"
                                        onValueChanged={onAnalyticalPlanValueChanged}
                                        placeholder='NA'
                                        value={analyticalPlan ? analyticalPlan.methodDocumentSection : undefined} >
                                        <Validator>
                                            <StringLengthRule message="Specification must be less than 500 characters in length." max={300} />
                                        </Validator>
                                    </TextBox>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="pw-form-unit pw-comp-40">
                        <div className="pw-form-unit-label">Specification</div>
                        <TextBox id="specification" className="textbox"
                            onValueChanged={onAnalyticalPlanValueChanged}
                            placeholder='NA'
                            value={analyticalPlan ? analyticalPlan.specification : undefined} >
                            <Validator>
                                <StringLengthRule message="Specification must be less than 500 characters in length." max={500} />
                            </Validator>
                        </TextBox>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Basis Types</div>
                            <List items={props.lookupData && props.lookupData.basisTypes ?
                                props.lookupData.basisTypes : []} keyExpr="id"
                                className="dx-listbox"
                                itemRender={DataTemplates.EhsTemplate}
                                showSelectionControls={true}
                                height="12rem" selectionMode="multiple"
                                onOptionChanged={analyticalBasisTypesChanged}
                                selectedItemKeys={analyticalPlanBasisTypesSelectedItemKeys ?
                                    analyticalPlanBasisTypesSelectedItemKeys : []} />
                        </div>

                        <div className="pw-form-unit pw-comp-20 ">
                            <div className="pw-form-unit-label">Applicable Characterizations</div>
                            <List items={props.lookupData && props.lookupData.scopeTypes ?
                                props.lookupData.scopeTypes : []} keyExpr="id"
                                className="dx-listbox"
                                height="12rem" selectionMode="multiple"
                                showSelectionControls={true}
                                itemRender={analysisScopesRender}
                                onOptionChanged={analysisScopeTypesChanged}
                                selectedItemKeys={analysisScopesSelectedItemKeys ?
                                    analysisScopesSelectedItemKeys : []} />
                        </div>
                    </div>

                </div>
            }

            {methodSearchByPartNumberDialogVisible &&
                <DialogPopup visible={methodSearchByPartNumberDialogVisible}
                    onHiding={hideMethodSearchByPartNumberDialog}
                    title="Search Methods by Part Number"
                    width='80vw'
                    height='80vh'
                    dragEnabled={false}
                    resizeEnabled={false}>

                    <SearchMethodsComponent
                        onApplySelection={onApplyMethodSearchClick} onCancel={onCancelMethodSearchClick} />

                </DialogPopup>
            }

        </div>
    );

    async function onApplyMethodSearchClick(methodSearch: MethodSearch) {
        if (methodSearch) {
            await getMethodByMethodId(methodSearch.methodId)
                .then(async (data) => {
                    let matchingMethod = data as Method;
                    if (matchingMethod) {
                        setAnalyticalPlan({
                            ...analyticalPlan, methodId: matchingMethod.methodId,
                            methodName: matchingMethod.methodName, methodStateName: matchingMethod.methodStateName
                        });
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Adding Method");
                });
        }

        hideMethodSearchByPartNumberDialog();
    }

    function onCancelMethodSearchClick() {
        hideMethodSearchByPartNumberDialog();
    }

    function onSaveClick() {
        saveAnalyticalPlanTechnologyDetails();
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    async function onCreateMethodClick() {
        if (!analyticalPlan)
            return;

        let newMethod: Method = {
            technologyId: analyticalPlan.analyticalTechnologyId,
            productId: analyticalPlan.productId
        };

        await insertMethod(newMethod, analyticalPlan.analyticalPlanId)
            .then((data) => {
                getAnalyticalPlanDetails();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Creating New Method");
            });
    }

    function onSearchMethodsClick() {
        showMethodSearchByPartNumberDialog();
    }

    async function analyticalBasisTypesChanged(e: any) {
        if (e.name === 'selectedItemKeys' && analyticalPlan) {
            setAnalyticalPlanBasisTypesSelectedItemKeys(e.value);

            //const removedItems = e.previousValue.filter(b => !e.value.includes(b));
            //const addedItems = e.value.filter(a => !e.previousValue.includes(a));

            setAnalyticalPlan({ ...analyticalPlan, basisTypesList: e.value });
        }
    }

    async function analysisScopeTypesChanged(e: any) {
        if (e.name === 'selectedItemKeys' && analyticalPlan) {
            setAnalysisScopesSelectedItemKeys(e.value);

            //const removedItems = e.previousValue.filter(b => !e.value.includes(b));
            //const addedItems = e.value.filter(a => !e.previousValue.includes(a));

            setAnalyticalPlan({ ...analyticalPlan, analysisScopeTypesList: e.value });
        }
    }

    async function onAnalyticalPlanValueChanged(e: any) {
        const caller = e.element.id as string;

        setAnalyticalPlan({ ...analyticalPlan, [caller]: e.value });
    }

    async function saveAnalyticalPlanTechnologyDetails() {
        let editedAnalyticalPlanTechnology: AnalyticalPlan = { ...analyticalPlan };

        await updateAnalyticalPlan(editedAnalyticalPlanTechnology)
            .then(() => {
                getAnalyticalPlanDetails();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Analytical Plan Technology");
            });
    }

    async function getAnalyticalPlanDetails() {
        if (props.analyticalPlanId)
            await CrudFunctions.getData(`analyticalplans/analyticalplan/${props.analyticalPlanId}`)
                .then(data => {
                    let analyticalPlanTechnology = data as AnalyticalPlan;

                    if (analyticalPlanTechnology) {
                        setAnalysisScopesSelectedItemKeys(analyticalPlanTechnology.analysisScopeTypesList);
                        setAnalyticalPlanBasisTypesSelectedItemKeys(analyticalPlanTechnology.basisTypesList);
                    }

                    setAnalyticalPlan(analyticalPlanTechnology);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Analytical Plan");
                });
    }

    async function getTestingLocationTypes() {
        await CrudFunctions.getData("common/testinglocationtypes")
            .then(data => {
                setTestingLocationTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Testing Location Types");
            });
    }

    async function getMethodSourceTypes() {
        await CrudFunctions.getData("common/methodsourcetypes")
            .then(data => {
                setMethodSourceTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Method Source Types");
            });
    }

    async function getMethodByMethodId(methodId: string) {
        return await CrudFunctions.getData(`methods/method/${methodId}`)
    }

    //INSERT functions

    async function insertMethod(newMethod: Method, analyticalPlanId: string) {
        return await CrudFunctions.postData(`methods/method/${analyticalPlanId}`, newMethod);
    }

    //UPDATE functions

    async function updateAnalyticalPlan(analyticalplantechnology: AnalyticalPlan) {
        return CrudFunctions.putData("analyticalplans/analyticalplantechnology", analyticalplantechnology);
    }

    async function getAllData() {
        await Promise.all([
            getMethodSourceTypes(),
            getTestingLocationTypes(),
            getAnalyticalPlanDetails()
        ]);
    }

    //rendering
    function analysisScopesRender(scope: LookupItem) {
        return (
            <div>
                <div>{scope.name}</div>
            </div>
        );
    }

    function showMethodSearchByPartNumberDialog() {
        setMethodSearchByPartNumberDialogVisible(true);
    }

    function hideMethodSearchByPartNumberDialog() {
        setMethodSearchByPartNumberDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }
}
